import React, { useEffect } from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { captureAttributionOnVisit, setPartnerTokenIfEmpty } from '../utils/attribution';

const RESERVED = new Set([
  'login', 'signin', 'signup', 'register', 'app', 'r', 'auth', 'getting-started', 'terms', 'privacy', 'cookie-policy',
  'account', 'settings', 'profile', 'refer', 'referrals', 'dashboard', 'chat', 'admin', 'agent', 'welcome', 'success', 'p',
]);

/**
 * /:partnerToken - partner link. Saves token and redirects to signup. Reserved paths redirect to home.
 */
export default function PartnerLinkRedirect() {
  const { partnerToken } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (partnerToken && !RESERVED.has(partnerToken.toLowerCase())) {
      setPartnerTokenIfEmpty(partnerToken);
    }
    captureAttributionOnVisit();
  }, [partnerToken]);

  if (!partnerToken || RESERVED.has(partnerToken.toLowerCase())) {
    return <Navigate to="/" replace />;
  }

  const search = searchParams.toString();
  const to = search ? `/signup?ref=${encodeURIComponent(partnerToken)}&${search}` : `/signup?ref=${encodeURIComponent(partnerToken)}`;
  return <Navigate to={to} replace />;
}
